export default {
	"helpers.ConversionFailed": "轉換失敗"
}